export enum Sounds {
    none = 0,
    tntExplode = 1,
    blobPop,
    blobPopMax,
    blobAbsorb,
    blobExert,
    blobHiccup,
    blobSpitOut,
    readySFX,
    goSFX,
    newHighScoreSFX,
    beatGameSFX,
    fruitSplat,
    whoosh,
    fruitLandSlow,
    fruitLandFast,
    splash,
    launch,
    duckDown,
    sparkle,
    fruitSmasher,
    unlockSFX,
    starMiss,
    starCollect,
    superStarCollect,
    bounce,
    coinCollect,
    coconutBombExplode,
    coconutBombWarning,
    moveUp,
    levelUp,
    speedUp,
    shapeBonus,
    lucky7,
    sixString,
    magic8,
    blackJack,
    gameOver,
    successfulPurchase,
    confirm,
    cancel,
    cupcakeCollect,

    TransitionToUrgent,
    TransitionToNormal,

    MusicTitle = 1000,
    Song1And2Fast,
    Song1Slow,
    Song2Slow,
    Song3Slow,
    Song4Slow,
    Song5Slow,
    Song5Fast,
}
